// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__iziI4","title":"ClientReferral_title__3kSKk","itemText":"ClientReferral_itemText__3pIX8"};